var styles = {"wrapper":"Checkbox-module_wrapper__KxWx-"};

export { styles as default };
